import { render } from "./MenuOptional.vue?vue&type=template&id=4832fdb4"
import script from "./MenuOptional.vue?vue&type=script&lang=js"
export * from "./MenuOptional.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__